export default __webpack_public_path__ + "76aa0fa455a905d2d9cc4e1770c78d06.riv";